import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, LoadingController, ModalController, ToastController, ViewController } from 'ionic-angular';
import { Meeting, Operator } from '../../models/models';
import { SettingsProvider } from '../../providers/settings/settings';
import { ApiProvider } from '../../providers/api/api';
import { AddMeetingPage } from '../add-meeting/add-meeting';
import { MeetingPage } from '../meeting/meeting';

/**
 * Generated class for the MeetingModalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-meeting-modal',
  templateUrl: 'meeting-modal.html',
})
export class MeetingModalPage {

  meeting: Meeting
  operator: Operator
  operator_id: number
  parent = null

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private alertCtrl: AlertController,
    private loading: LoadingController,
    private settings: SettingsProvider,
    private api: ApiProvider,
    private modalCtrl: ModalController,
    private toastCtrl: ToastController,
    private viewController: ViewController
  ) {
    this.meeting = (navParams && navParams.get('meeting')) || null
    this.operator = (navParams && navParams.get('operator')) || null
    this.parent = (navParams && navParams.get('parent')) || null
    this.operator_id = this.operator.id
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad MeetingModalPage');
  }

  meetingUnDone() {
    this.close()
    // Chiedo Conferma

    this.alertCtrl.create({
      title: "Appuntamento non fatto",
      message: "Confermi la scelta?",
      buttons: [
        {
          text: "Indietro",
          handler: () => { }
        },
        {
          text: "Conferma",
          handler: () => {

            // Aggiorno Stato appuntamento

            this.parentRefresh()

            let l = this.showLoader()
            this.meeting.status = this.settings.MEETING_CANCEL

            this.api.patchMeeting(this.operator_id, this.meeting).subscribe(
              _ => {
                l.dismiss()

                this.alertCtrl.create({
                  title: "Fissa Nuovo Appuntamento",
                  message: "Vuoi fissare un nuovo appuntamento?",
                  buttons: [
                    {
                      text: "No",
                      handler: () => {

                        // Aggiorno Stage Attuale

                        let l = this.showLoader()
                        this.meeting.deal.current_stage = this.settings.STAGE_APPOINTMENT_UNDONE_BY_PRODUCT[this.meeting.deal.product.ac_label]
                        this.api.patchDeal(this.meeting.deal).subscribe(_ => { l.dismiss() }, _e => { l.dismiss() })
                      }
                    },
                    {
                      text: "Si",
                      handler: () => {

                        // Sposto appuntamento

                        this.moveMeeting()

                      }
                    }
                  ]
                }).present()
              },
              _e => {
                l.dismiss()
              })
          }
        }
      ]
    }).present()

  }

  meetingDone() {
    // Chiedo Conferma

    this.alertCtrl.create({
      title: "Appuntamento Fatto",
      message: "Confermi la scelta?",
      buttons: [
        {
          text: "Indietro",
          handler: () => { }
        },
        {
          text: "Conferma",
          handler: () => {

            // Aggiorno Stato appuntamento

            let l = this.showLoader()
            this.meeting.status = this.settings.MEETING_DONE
            this.meeting.deal.current_stage = this.settings.STAGE_APPOINTMENT_DONE_BY_PRODUCT[this.meeting.deal.product.ac_label]
            this.api.patchMeeting(this.operator_id, this.meeting)
              .concatMap(_meeting => this.api.patchDeal(this.meeting.deal))
              .subscribe(
                _ => {
                  this.parentRefresh()

                  l.dismiss()
                  this.notifyOk()
                  this.close()
                  this.navCtrl.push(MeetingPage, {
                    meeting: this.meeting,
                    parent: this.parent,
                    operator: this.operator
                  })
                },
                _e => {
                  l.dismiss()
                  this.notifyError()
                  this.close()
                }
              )
          }
        }
      ]
    }).present()

  }

  showLoader() {
    let l = this.loading.create({
      content: "Attendere.."
    })
    l.present()
    return l
  }

  moveMeeting() {
    let meetingModal = this.modalCtrl.create(AddMeetingPage,
      {
        contact: this.meeting.deal.contact,
        deal: this.meeting.deal,
        silent: true,
        notes: this.meeting.notes,
        place: this.meeting.place
      })
    meetingModal.onDidDismiss(value => {
      if (value != null) {
        this.toastCtrl.create({
          message: 'Appuntamento spostato con successo',
          duration: 2000,
          position: 'top'
        }).present()
        this.parentRefresh()
      } else {
        this.toastCtrl.create({
          message: 'Si è verificato un errore',
          duration: 2000,
          position: 'top'
        }).present()
      }
      this.close()
    })
    meetingModal.present()
  }

  parentRefresh() {
    this.parent && this.parent.refresh && this.parent.refresh()
  }

  notifyOk() {
    this.toastCtrl.create({
      message: 'Operazione conclusa con successo',
      duration: 2000,
      position: 'top'
    }).present()
  }

  notifyError(e: string = "") {
    this.toastCtrl.create({
      message: 'Si è verificato un errore ' + e,
      duration: 2000,
      position: 'top'
    }).present()
  }

  close() {
    this.viewController.dismiss(null);
  }

}



// WEBPACK FOOTER //
// ./src/pages/meeting-modal/meeting-modal.ts